'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.controller("ticketAddMessagePopinController", function ($scope, $http, $session) {
  // par sécurité on copie le ticket
  var ticket = $scope.ticket = angular.copy($scope.ticket);
  $scope.echange = {
    message: null
  };
  $scope.isMessageEmpty = function () {
    var isEmpty = $scope.echange.message == null || $scope.echange.message.trim().length === 0;
    console.log(isEmpty);
    return isEmpty;
  };
  $scope.saveMessage = function () {
    $http.post('/rest/echange/ticket-client/add-message/' + $scope.ticket.id, null, {
      params: $scope.echange
    }).then(function () {
      $scope.$close();
    });
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ticket/fiche/addMessage/ticketAddMessagePopinController.js
// module id = 2893
// module chunks = 13